import {environment} from '../../environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class ApiRoutes {
  readonly REFRESH_TOKEN: string = environment.apiUrl + 'backend/token/refreshToken';
  readonly NOTIFICATIONS: string = environment.apiUrl + 'api/notification';
  readonly NOTIFICATION_DETAILS: string = environment.apiUrl + 'api/notification/{0}';
  readonly NOTIFICATION_PROMOTE: string = environment.apiUrl + 'api/notification/{0}/promoteToIssue';
  readonly NOTIFICATION_WITHOUT_CONSEQUENCE: string = environment.apiUrl + 'api/notification/{0}/withoutConsequence';
  readonly NOTIFICATION_OPEN: string = environment.apiUrl + 'api/notification/{0}/open';
  readonly NOTIFICATION_MULTIMEDIA: string = environment.apiUrl + 'api/notification/{0}/multimedia';
  readonly NOTIFICATION_MULTIMEDIUM_SEND_TO_ISSUE: string = environment.apiUrl + 'api/notification/{0}/copyMultimedia';
  readonly NOTIFICATION_MULTIMEDIUM: string = environment.apiUrl + 'api/notification/{0}/multimedia/{1}';
  readonly NOTIFICATION_BY_BUILDINGS: string = environment.apiUrl + 'api/building/ListWithIssueInfo';
  readonly NOTIFICATION_MARK_AS_READ: string = environment.apiUrl + 'api/notification/{0}/markMessagesAsRead';
  readonly NOTIFICATION_MESSAGE_ADD: string = environment.apiUrl + 'api/NotificationMessage';
  readonly MESSAGES: string = environment.apiUrl + 'api/notificationMessage';
  readonly RESIDENTS: string = environment.apiUrl + 'api/resident';
  readonly RESIDENT_DETAILS: string = environment.apiUrl + 'api/resident/{0}/{1}';
  readonly RESIDENT_INVITE: string = environment.apiUrl + 'api/resident/{0}/{1}/invite';
  readonly RESIDENT_INVITE_MULTIPLE: string = environment.apiUrl + 'api/resident/invite-multiple';
  readonly RESIDENT_DOCUMENT_UPDATE_VISIBILITY: string = environment.apiUrl + 'api/resident/{0}/document/{1}/updateVisibility';
  readonly BUILDING_DOCUMENTS: string = environment.apiUrl + 'api/buildingDocument';
  readonly BUILDING_DOCUMENT_UPDATE_VISIBILITY: string = environment.apiUrl + 'api/buildingDocument/{0}/{1}/updateVisibility';
  readonly ERROR_LOG: string = environment.apiUrl + 'api/errorHandling';
  readonly BUILDINGS: string = environment.apiUrl + 'api/building';
  readonly BUILDINGS_BY_CONTACT: string = environment.apiUrl + 'api/building/{0}';
  readonly BUILDING_TEMPLATE_LOCATIONS: string = environment.apiUrl + 'api/templateLocation';
  readonly BUILDING_LOCATIONS: string = environment.apiUrl + 'api/building/{0}/locations'
  readonly RESIDENT_DOCUMENTS: string = environment.apiUrl + 'api/resident/{0}/{1}/documents';
  readonly RESIDENT_BUILDING_DOCUMENTS: string = environment.apiUrl + 'api/resident/{0}/{1}/buildingDocuments';
  readonly RESIDENT_STRUCTURES: string = environment.apiUrl + 'api/resident/{0}/{1}/structures';
  readonly RESIDENT_LOCATIONS: string = environment.apiUrl + 'api/resident/{0}/{1}/locations';
  readonly RESIDENT_NOTIFICATIONS: string = environment.apiUrl + 'api/resident/{0}/{1}/notifications';
  readonly ANNOUNCEMENTS: string = environment.apiUrl + 'api/announcement';
  readonly ANNOUNCEMENT_DETAILS: string = environment.apiUrl + 'api/announcement/{0}';
  readonly ANNOUNCEMENT_RESEND_ALL: string = environment.apiUrl + 'api/announcement/{0}/resend-all';
  readonly ANNOUNCEMENT_RESEND_UNREAD: string = environment.apiUrl + 'api/announcement/{0}/resend-unread';
  readonly ANNOUNCEMENT_MULTIMEDIA: string = environment.apiUrl + 'api/announcement/{0}/multimedia';
  readonly ANNOUNCEMENT_MULTIMEDIA_ADD: string = environment.apiUrl + 'api/announcement/{0}/document/file';
  readonly ANNOUNCEMENT_MULTIMEDIA_DELETE: string = environment.apiUrl + 'api/announcement/{0}/document/{1}';
  readonly ANNOUNCEMENT_RESIDENTS: string = environment.apiUrl + 'api/announcement/{0}/residents';
  readonly APPLICATION_STYLE: string = environment.apiUrl + 'api/applicationStyleSettings';
  readonly BUSINESS_STYLE_LOGO: string = environment.apiUrl + 'api/applicationStyleSettings/logo';
  readonly BUSINESS_SIGNIN_BACKGROUND: string = environment.apiUrl + 'api/applicationStyleSettings/signInBackground';
  readonly LOGIN: string = environment.apiUrl + 'api/login';
  readonly LOGIN_DETAILS: string = environment.apiUrl + 'api/login/{0}';
  readonly LOGIN_INVITE: string = environment.apiUrl + 'api/login/{0}/invite';
  readonly BUSINESS_SPF_RECORDS: string = environment.apiUrl + 'api/business/spfinfo';
  readonly BUSINESS_SPF_RECORD: string = environment.apiUrl + 'api/business/spfinfo/{0}';
  BUSINESS_EMAIL_FROM_ADDRESS: string = environment.apiUrl + 'api/business/email/from-address';

  public getRouteWithInjectedParams(route: string, values: string[]): string {
    let result: string = route;
    for (let i = 0; i < values.length; i++) {
      result = result.replace(`{${i}}`, values[i]);
    }
    return result;
  }
}
